/**
 * 活动模块
 */

import { PAGE_LEVEL } from '@/constants';
import { isElectron } from '@/utils/electron';
import { ACTIVITY_ORIGIN_TYPE } from '@/pages/scheduleModule/activity/activityOriginType';

export default {
  meta: { localeModules: ['roadshow', 'research', 'schedule', 'eventSignal', 'strategy', 'daily'] },
  path: '/activity',
  children: [
    // 市场活动 路演
    {
      path: 'roadshow',
      name: 'ActivityRoadshow',
      // 更换新组件
      component: () =>
        import(/* webpackChunkName: 'activity-roadshow' */ '@/pages/scheduleModule/activity/activityMain.vue'),
      meta: {
        name: 'common.noun.activity',
        // 页面组件名称 用于缓存
        componentName: 'ActivityRoadshowIndex',
        keepAlive: true,
        pageLevel: PAGE_LEVEL.FIRST
      }
    },
    // 市场活动 调研：重定向到 activity/roadshow，带 tab=调研 自动定位到调研 Tab（ResearchActivity）
    {
      path: 'survey',
      name: 'ActivitySurvey',
      redirect: () => ({ path: '/activity/roadshow', query: { tab: ACTIVITY_ORIGIN_TYPE.RESEARCH } }),
      meta: {
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'common.noun.activity'
      }
    },
    // 市场活动 策略会：重定向到 activity/roadshow，带 tab=策略会 自动定位到策略会 Tab
    {
      path: 'strategy',
      name: 'ActivityStrategy',
      redirect: () => ({ path: '/activity/roadshow', query: { tab: ACTIVITY_ORIGIN_TYPE.STRATEGY } }),
      meta: {
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'common.noun.activity'
      }
    },
    // 我司会议
    {
      path: 'meeting',
      name: 'ActivityMeeting',
      // TODO: 临时注释
      redirect: '/activity/roadshow',
      component: () =>
        import(/* webpackChunkName: 'activity-meeting-meeting' */ '@/pages/scheduleModule/companyMeeting/index.vue'),
      meta: {
        // 页面组件名称 用于缓存
        componentName: 'ActivityMeetingIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'routers.activity_activity_meeting'
      }
    },
    //微信平台（首页已下线，仅保留三条详情路由从外部进入）
    {
      path: 'wechat',
      name: 'ActivityWechat',
      redirect: '/activity/roadshow',
      children: [
        // 路演
        {
          path: 'roadshow/:id',
          name: 'wechatRoadshowDetail',
          component: () =>
            import(
              /* webpackChunkName: 'activity-wechat' */ '@/pages/scheduleModule/wechatPlatform/roadshowDetail.vue'
            ),
          meta: {
            componentName: 'ActivityWechatRoadshowDetail',
            name: 'routers.activity_wetchat_roadshowDetail',
            pageLevel: PAGE_LEVEL.SECOND,
            parent: '/activity/roadshow',
            keepAlive: false,
            electronSingle: true,
            hideBreadcrumb: isElectron
          }
        },
        // 调研
        {
          path: 'survey/:id',
          name: 'wechatSurveyDetail',
          component: () =>
            import(/* webpackChunkName: 'activity-wechat' */ '@/pages/scheduleModule/wechatPlatform/surveyDetail.vue'),
          meta: {
            componentName: 'ActivityWechatSurveyDetail',
            name: 'routers.activity_wetchat_surveyDetail',
            pageLevel: PAGE_LEVEL.SECOND,
            parent: '/activity/roadshow',
            keepAlive: false,
            electronSingle: true,
            hideBreadcrumb: isElectron
          }
        },
        // 策略会
        {
          path: 'strategy/:id',
          name: 'wechatStrategyDetail',
          component: () =>
            import(
              /* webpackChunkName: 'activity-wechat' */ '@/pages/scheduleModule/wechatPlatform/strategyDetail.vue'
            ),
          meta: {
            componentName: 'ActivityWechatStrategyDetail',
            name: 'routers.activity_wetchat_strategyDetail',
            pageLevel: PAGE_LEVEL.SECOND,
            parent: '/activity/roadshow',
            keepAlive: false,
            electronSingle: true,
            hideBreadcrumb: isElectron
          }
        }
      ]
    }
  ]
};
